
export const _resolutions = [
    {
        title: 'Resolución 1025 de 2021 MINISTERIO DE VIVIENDA CIUDAD Y TERRITORIO',
        contents: 'Por medio de la cual se modifica la Resolución 0462 de 2017, relacionada con los documentos que deberán acompañar las solicitudes de licencias urbanísticas y de modificación de las licencias urbanísticas vigentes.',
        link: 'https://curaduria1bucaramanga.com/public_docs/OTHERS/resolucion-1025_2021.pdf'
    },
    {
        title: 'Resolución 1026 de 2021 MINISTERIO DE VIVIENDA CIUDAD Y TERRITORIO ',
        contents: 'Por medio de la cual se modifica la Resolución 463 de 2017, relacionada con el Formulario Único Nacional para la solicitud de licencias urbanísticas y el reconocimiento de edificaciones y otros documentos.',
        link: 'https://curaduria1bucaramanga.com/public_docs/OTHERS/resolucion-1026_2021.pdf'
    },
    {
        title: 'Resolución 0017 de 2017 COMISIÓN ASESORA PERMANENTE PARA EL RÉGIMEN DE CONSTRUCCIONES SISMO RESISTENTE ',
        contents: 'Por medio de la cual se actualiza la Resolución 0015 de octubre 15 de 2015 respecto a los procedimientos para fijar el alcance de las labores profesionales y establecer los honorarios mínimos que se utilicen para retribuir las labores mencionadas en el artículo 42 de la Ley 400 de 1997.',
        link: 'https://curaduria1bucaramanga.com/public_docs/OTHERS/Resolución 0017 del 04-12-2017_0.pdf'
    },
    {
        title: 'Resolución 0462 - 2017',
        contents: 'Documentos que deberán acompañar las solicitudes de licencias urbanísticas.',
        link: 'https://minvivienda.gov.co/normativa/resolucion-0462-2017-0'
    }
]